"use client";

import {
  Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Theme,
} from "@mui/material";
import { ArrowDownward, CheckCircle } from "@mui/icons-material";
import { NumericFormat } from "react-number-format";

import { SLCalcResultDisplay } from "./SLCalcResultDisplay";

type AbfindungSummaryMessages = {
  summary: {
    company10Plus: string;
    companyUnder10: string;
    employmentDuration: string;
    yearsSuffix: string;
  };
};

export function AbfindungStickySummary({
  theme,
  counter,
  isMoreThan10,
  isMonthlyIncomeConfirmed,
  isCalculationStarted,
  monthlyIncome,
  beschäftigungsdauerInJahren,
  untergrenze,
  obergrenze,
  abfindung,
}: {
  theme: Theme;
  counter: number;
  isMoreThan10: boolean | undefined;
  isMonthlyIncomeConfirmed: boolean;
  isCalculationStarted: boolean;
  monthlyIncome: number;
  beschäftigungsdauerInJahren: number;
  untergrenze: string;
  obergrenze: string;
  abfindung: AbfindungSummaryMessages;
}) {
  return (
    <Stack
      sx={{
        width: "100%",
        boxShadow: "none",
        borderRadius: 0,
        position: "relative",
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Stack
        direction="column"
        gap={3}
        sx={{
          width: "100%",
          height: "fit-content",
          alignItems: "center",
          p: 1,
          py: 2,
        }}
      >
        {counter > 0 && (
          <Stack
            sx={{
              p: 1,
              borderRadius: `${theme.shape.borderRadius}px`,
              backgroundColor: theme.palette.primary.light,
              width: "100%",
            }}
          >
            <List dense>
              {isMoreThan10 !== undefined &&
                (isMoreThan10 ? (
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircle color="success" />
                    </ListItemIcon>
                    <ListItemText>
                      {abfindung.summary.company10Plus}
                    </ListItemText>
                  </ListItem>
                ) : (
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircle color="success" />
                    </ListItemIcon>
                    <ListItemText>
                      {abfindung.summary.companyUnder10}
                    </ListItemText>
                  </ListItem>
                ))}

              {isMonthlyIncomeConfirmed && (
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle color="success" />
                  </ListItemIcon>
                  <ListItemText>
                    Bruttoverdienst:{" "}
                    <NumericFormat
                      value={monthlyIncome}
                      displayType="text"
                      thousandSeparator={"."}
                      decimalScale={0}
                      suffix=" €"
                      decimalSeparator={","}
                    />
                  </ListItemText>
                </ListItem>
              )}

              {isCalculationStarted && (
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle color="success" />
                  </ListItemIcon>
                  <ListItemText>
                    {abfindung.summary.employmentDuration}{" "}
                    <NumericFormat
                      value={beschäftigungsdauerInJahren}
                      displayType="text"
                      thousandSeparator={"."}
                      decimalScale={0}
                      suffix={abfindung.summary.yearsSuffix}
                      decimalSeparator={","}
                    />
                  </ListItemText>
                </ListItem>
              )}
            </List>
          </Stack>
        )}
        {counter > 0 && <ArrowDownward />}

        {isCalculationStarted && obergrenze && untergrenze ? (
          <SLCalcResultDisplay
            untergrenze={untergrenze}
            obergrenze={obergrenze}
            isActive={isCalculationStarted}
          />
        ) : (
          <Alert severity="warning">
            Beantworten Sie alle Fragen, um das Ergebnis zu erhalten.
          </Alert>
        )}
      </Stack>
    </Stack>
  );
}
